var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-wheel-wrapper"},[_c('FortuneWheel',{attrs:{"canvas":_vm.canvasOptions,"prizes":_vm._prizes,"verify":_vm.canvasVerify,"disabled":_vm.loading,"prizeId":_vm.prizeId},on:{"rotateStart":_vm.onCanvasRotateStart,"rotateEnd":_vm.onRotateEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }